module.exports = __webpack_public_path__ + "static/program-uni765994-af60e5b3adb0de8f1c16e1b86e3aeca9.png";